/* ============
 * Athlete Transformer
 * ============
 *
 * The transformer for an athlete
 */

import Transformer from './transformer'

export default class athleteTransformer extends Transformer {
  /**
   * Method used to transform a fetched athlete
   *
   * @param athlete The fetched athlete
   *
   * @returns {Object} The transformed athlete
   */
  static fetch (athlete) {
    let decades = new Set();
    if (athlete['property_Decade']) {
      athlete['property_Decade'].forEach((entry) => {
        entry.slice(0, -1).split('s').forEach(decade => decades.add(decade));
      });
    }
    return {
      id: athlete['id'],
      date_inducted: athlete['property_Date_Inducted'],
      decades: decades,
      description: athlete['description'],
      ppdbid: athlete['property_Inductee_Person'],
      thumbnail_url: athlete['thumbnails']['thul'],
      photograph_url: athlete['original'] ? athlete['original'] : athlete['thumbnails']['webimage'],
      title: athlete['name'],
    }
  }
}
